import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SHOP_CATEGORIES, SHOP_PRODUCTS } from '../data/shop';
import { ShopCard } from '../components/ShopCard';
import { Reveal } from '../components/Reveal';
import { Note, ArrowMark } from '../components/Marks';
import { useShop } from '../ShopContext';
export function Shop() {
  const [params, setParams] = useSearchParams();
  const {
    count
  } = useShop();
  const category = params.get('kategori') ?? '';
  const shipping = params.get('frakt') ?? '';
  const setParam = (key: string, value: string) => {
    const next = new URLSearchParams(params);
    if (value) next.set(key, value);else next.delete(key);
    setParams(next, {
      replace: true
    });
  };
  const results = useMemo(() => SHOP_PRODUCTS.filter(p => {
    if (category && p.category !== category) return false;
    if (shipping === 'frakt' && p.shipping !== 'frakt') return false;
    return true;
  }), [category, shipping]);
  const chip = (active: boolean) => `border px-4 py-2 text-[11px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out ${active ? 'border-black bg-black text-papper' : 'border-black/20 hover:border-black'}`;
  return <div className="mx-auto max-w-page px-5 py-12 md:px-8 md:py-16" data-id="element-1267" data-mp="3rbovc4vq200n">
      <Reveal data-id="element-1268" data-mp="3rawyyruavy9b">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-1269" data-mp="3rdj64qda4br0">
          <div data-id="element-1270" data-mp="2un0hlkr1gyx1">
            <p className="text-[11px] font-bold uppercase tracking-wide3 text-blaa" data-id="element-1271" data-mp="2unim14nuujg1">Butiken</p>
            <h1 className="display-xl mt-3 text-5xl uppercase sm:text-7xl" data-id="element-1272" data-mp="2zksg4xm6vja7">Ta hem Småland</h1>
            <Note className="mt-3 block" data-id="element-1273" data-mp="33ksxor4l4alh">Sånt vi själva har i skafferiet.</Note>
          </div>
          {count > 0 && <Link to="/kassa" className="group flex items-center gap-2 bg-blaa px-7 py-4 text-[12px] font-bold uppercase tracking-wide2 text-papper transition-colors duration-150 ease-out hover:bg-black" data-id="element-1274" data-mp="38iuhje9u4dy0">
              Till kassan ({count})
              <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-1275" data-mp="2k07ef5uk260t" />
            </Link>}
        </div>
      </Reveal>

      <Reveal delay={0.05} data-id="element-1276" data-mp="2tuz7pxh3u6ps">
        <div className="mt-10 flex flex-wrap items-center gap-2 border-t-2 border-black pt-6" data-id="element-1277" data-mp="2tu7nfisyjvet">
          <button onClick={() => setParam('kategori', '')} className={chip(!category)} data-id="element-1278" data-mp="2ov4irzgw3r7d">
            Allt
          </button>
          {SHOP_CATEGORIES.map(c => <button key={c} onClick={() => setParam('kategori', category === c ? '' : c)} className={chip(category === c)} data-id="element-1279" data-mp="1w9uvz11ooqvz">
              {c}
            </button>)}
          <button onClick={() => setParam('frakt', shipping === 'frakt' ? '' : 'frakt')} className={`${chip(shipping === 'frakt')} ml-auto`} data-id="element-1280" data-mp="264mtk4v9ndqr">
            Kan skickas
          </button>
        </div>
      </Reveal>

      <p className="mt-8 text-[11px] font-bold uppercase tracking-wide2 text-black/45" data-id="element-1281" data-mp="3p55l8hb5zyfj">
        {results.length} produkter
      </p>

      {results.length === 0 ? <div className="mt-6 border-y-2 border-black py-20 text-center" data-id="element-1282" data-mp="3g4pl9htmr9ff">
          <p className="display-xl text-3xl uppercase" data-id="element-1283" data-mp="3g6k6kx8td3k1">Inget här. Än.</p>
          <p className="mt-3 text-black/60" data-id="element-1284" data-mp="3k743q0te0766">Släpp ett filter så dyker det upp mer.</p>
        </div> : <div className="mt-6 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1285" data-mp="br0w1v29yihu">
          {results.map((product, i) => <Reveal key={product.id} delay={Math.min(i * 0.04, 0.2)} data-id="element-1286" data-mp="gn83jsabk21w" data-mpi={i}>
              <ShopCard product={product} data-id="element-1287" data-mp="2pb3un0kjfj0" />
            </Reveal>)}
        </div>}

      <Reveal data-id="element-1288" data-mp="7ncmx7xzveuh">
        <aside className="mt-20 border-2 border-black p-8 md:p-10" data-id="element-1289" data-mp="7n2y3noordqd">
          <h2 className="display-xl text-3xl uppercase sm:text-4xl" data-id="element-1290" data-mp="2nf0gctdsup8j">Beställer ni till kontoret?</h2>
          <p className="mt-3 max-w-xl leading-relaxed text-black/70" data-id="element-1291" data-mp="2sg6fpa1ytar1">
            Företagskunder kan handla mot faktura och lägga en stående order — fredagsfika varje vecka,
            presentlådor till jul, kaffe som aldrig tar slut. Välj faktura i kassan så ordnar vi resten.
          </p>
        </aside>
      </Reveal>
    </div>;
}